var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 3.5L19 8.22222M14.3333 3.5H6C5.44771 3.5 5 3.94772 5 4.5V19.5C5 20.0523 5.44772 20.5 6 20.5H18C18.5523 20.5 19 20.0523 19 19.5V8.22222M14.3333 3.5V7.22222C14.3333 7.77451 14.781 8.22222 15.3333 8.22222H19",
    stroke: "#051B46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafts);
export default __webpack_public_path__ + "static/media/Drafts.376ae9f527285d107d234546bce8b3e1.svg";
export { ForwardRef as ReactComponent };